// extracted by mini-css-extract-plugin
export var adjacentSlide = "_pg-9";
export var arrowButtonContainer = "_pg-5";
export var arrowButtonIcon = "_pg-6";
export var carouselArrowButton = "_pg-2";
export var carouselElementContainer = "_pg-1";
export var currentSlide = "_pg-8";
export var left = "_pg-3";
export var otherSlide = "_pg-a";
export var productCarouselContainer = "_pg-0";
export var right = "_pg-4";
export var sliderOverflow = "_pg-7";